import { API } from "./../../../api/config";

export const getProductBypartner = (params) => {
    return API.get("/pmbpartner/partner-products", { params })
              .then((res) => res);
};
export const updateProductPartnerAPI = (params) => {
    return API.patch(`/pmbpartner/partner-products/${params.partnerProductSK}`, params.body)
              .then((res) => res);
};